import { render } from "./DocumentList.vue?vue&type=template&id=5d9b6342&scoped=true&ts=true"
import script from "./DocumentList.vue?vue&type=script&lang=ts"
export * from "./DocumentList.vue?vue&type=script&lang=ts"

import "./DocumentList.vue?vue&type=style&index=0&id=5d9b6342&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9b6342"]])

export default __exports__